import { gql } from "apollo-boost";

export const getListOfTransactionsQuery = gql`
  query($offset: Int, $pageNo: Int, $shortDescription: String) {
    getListofTransaction(
      NoOfRows: $offset
      offset: $pageNo
      shortDescription: $shortDescription
    ) {
      Id
      shortDescription
      longDescription
    }
  }
`;

export const getTransactionByIdQuery = gql`
  query($id: Int!) {
    getTransactionById(id: $id) {
      Id
      shortDescription
      longDescription
      allowEditing
    }
  }
`;

export const getListOfAutoNumeringQuery = gql`
  query($transactionType: Int!) {
    getListofAutoNumbering(transactionType: $transactionType) {
      Id
      transactionType
      startDate
      endDate
      nextNumber
      returnsAs
    }
  }
`;

export const getAutoNumeringQuery = gql`
  query($id: Int) {
    findAtriaUserById(id: $id) {
      id
      name
      designation
      userId
      emailId
      status
      statusDetail {
        name
      }
      lastModifiedOn
      lastModifiedBy
      createdOn
      mobileNumber
      createdBy
    }
  }
`;

export const createAutoNumberingQuery = gql`
  mutation(
    $transactionType: Int!
    $startDate: Date!
    $endDate: Date!
    $nextNumber: Int!
    $returnAs: String!
    $prefix: String
    $suffix: String
    $padding: String
    $nextNoLen: Int
  ) {
    createAutoNumbering(
      data: {
        transactionType: $transactionType
        startDate: $startDate
        endDate: $endDate
        nextNumber: $nextNumber
        returnsAs: $returnAs
        prefix: $prefix
        suffix: $suffix
        padding: $padding
        nextNoLen: $nextNoLen
      }
    ) {
      autoNumbering {
        Id
      }
    }
  }
`;

export const updateAutoNumberingQuery = gql`
  mutation(
    $id: String!
    $startDate: Date!
    $endDate: Date!
    $nextNumber: Int!
    $returnAs: String!
    $prefix: String
    $suffix: String
    $padding: String
    $nextNoLen: Int
  ) {
    updateAutoNumbering(
      id: $id
      data: {
        startDate: $startDate
        endDate: $endDate
        nextNumber: $nextNumber
        returnsAs: $returnAs
        prefix: $prefix
        suffix: $suffix
        padding: $padding
        nextNoLen: $nextNoLen
      }
    ) {
      message
    }
  }
`;

export const deleteAutoNumberingQuery = gql`
  mutation($id: String!) {
    deleteAutoNumbering(id: $id) {
      message
    }
  }
`;
